import { render, staticRenderFns } from "./ChainingSelector.vue?vue&type=template&id=483fc07d&"
import script from "./ChainingSelector.vue?vue&type=script&lang=ts&"
export * from "./ChainingSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports